// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"7c9d0f69","453":"bd1ed8e5","627":"bd8770d6","738":"13e9446a","923":"ff3b09be"}[chunkId] + ".chunk.js";
};